import React from 'react';
import {
  Box,
  Breadcrumb,
  Layout,
  Leaf,
  PrimaryButton,
  Title,
} from '@src/shared/ui';
import { useTermsController } from './use-terms-controller';
import './terms.css';

type TermsPageProps = {
  title?: string;
  messageHtml?: string;
  children?: React.ReactNode;
  tree?: Leaf[];
  continueButton?: boolean;
  footerID?: string;
  hiddenBreadcrumb?: boolean;
  hiddenTitle?: boolean;
  headerID?: string;
  adoptLayoutExternalPublic?: boolean;
};

export const TermsPage: React.FC<TermsPageProps> = ({
  messageHtml,
  children,
  hiddenBreadcrumb,
  tree,
  footerID,
  headerID,
  hiddenTitle,
  title,
  continueButton,
  adoptLayoutExternalPublic,
}) => {
  const { isFixed, toHome } = useTermsController();

  return (
    <Layout
      header={{
        id: headerID,
        continueButton,
        goToHome: toHome,
        iconLeft: adoptLayoutExternalPublic ? null : 'help',
      }}
      footer={{
        className: isFixed ? 'hidden sm:flex' : 'flex',
        id: footerID,
      }}
      removeGrid={hiddenBreadcrumb}
    >
      <Box
        className={`
          col-span-4
          sm:col-span-12
          flex-1 
        `}
      >
        {!adoptLayoutExternalPublic &&
          (hiddenBreadcrumb ? null : (
            <Breadcrumb className='hidden sm:block sm:mt-8' tree={tree} />
          ))}
        {hiddenTitle ? null : (
          <Title
            fontWeight='bold'
            className={`mt-8 ${adoptLayoutExternalPublic ? 'sm:mt-14' : 'sm:mt-10'} text-[24px] sm:text-[40px]`}
          >
            {title}
          </Title>
        )}
        {children ? (
          <div
            className={
              hiddenBreadcrumb
                ? adoptLayoutExternalPublic
                  ? ''
                  : 'mb-[105px] sm:mb-0'
                : `flex-1 mt-4 sm:mt-6 ${adoptLayoutExternalPublic ? 'mb-12 sm:mb-[72px]' : 'mb-32 sm:mb-10'}`
            }
          >
            {children}
          </div>
        ) : (
          <div
            className='flex-1 mt-4 mb-32 sm:mt-6 sm:mb-10'
            dangerouslySetInnerHTML={{
              __html: messageHtml,
            }}
          />
        )}
        {!adoptLayoutExternalPublic && (
          <Box
            className={`
              flex
              flex-wrap
              left-0
              bottom-0
              bg-white
              ${isFixed ? 'w-full' : 'w-auto'}
              py-6
              rounded-tl-2xl
              rounded-tr-2xl

              shadow-[0px_-4px_30px_0px_rgba(0,0,0,0.07)]
              ${isFixed ? 'fixed' : hiddenBreadcrumb ? 'pt-0 -mt-[113px] shadow-none' : 'pt-0 -mx-6 sm:-mx-10 -mt-[113px] shadow-none'}
              ${hiddenBreadcrumb ? 'sm:hidden' : ''}

              sm:mx-0
              sm:mt-0
              sm:bg-neutral-0
              sm:relative
              sm:w-full
              sm:py-0
              sm:rounded-tr-0
              sm:rounded-tl-0
              sm:shadow-none
            `}
          >
            <PrimaryButton
              onClick={toHome}
              className={`
                  ${isFixed ? '' : 'mt-10'}
                  mx-6
                  px-6
                  flex-1
                  sm:min-w-[257px]
                  sm:max-w-[404px]
                  sm:mx-0
                  sm:mb-20
                `}
            >
              Voltar para o parcelamento
            </PrimaryButton>
          </Box>
        )}
      </Box>
    </Layout>
  );
};
